import { useEffect } from 'react'

const GTM_ID = 'GTM-T7RVBPK6'
const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`

/** Carga Google Tag Manager una sola vez, con el respaldo noscript. */
export function useGoogleTagManager(): void {
  useEffect(() => {
    if (document.querySelector(`script[src="${GTM_SRC}"]`)) return

    const w = window as unknown as Record<string, any>
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = GTM_SRC
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'
    noscript.appendChild(iframe)
    document.body.insertBefore(noscript, document.body.firstChild)
  }, [])
}
